import React from 'react';

interface LoadingStateProps {
  message?: string;
}

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message = "Loading stock data..." }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <div className="text-red-500 text-xl mb-4">⚠️ Error</div>
        <p className="text-gray-600 mb-4">{error}</p>
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

interface NoDataStateProps {
  message?: string;
}

export const NoDataState: React.FC<NoDataStateProps> = ({ message = "No data available" }) => {
  return (
    <div className="text-center py-12">
      <p className="text-gray-600">{message}</p>
    </div>
  );
};
